import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M4_FordFulkerson = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Ford-Fulkerson Algorithm - Maximum Flow Problem"
      videos={["https://www.youtube.com/embed/Iwc3Uj4aaF4", "https://www.youtube.com/embed/3LG-My_MoWc", "https://www.youtube.com/embed/NwenwITjMys"]}
      takeaways={[
        { text: "Uses augmenting paths to find available flow from source → sink." },
        { text: "Can use DFS (or BFS in special cases like Edmonds-Karp)." },
        { text: "Keeps updating the residual graph until no more augmenting paths exist." },
        { text: "Works well for small graphs with integer capacities." },
        { text: "Worst case: If floating-point capacities are used, it may run indefinitely." },
        { text: "Time Complexity: O(E * max_flow) (depends on flow value)." },
        { text: "Example Use Case: Finding max flow in small networks with bounded capacities." },
      ]}
      questions={["Find the maximum network flow in the graph below and analyze its time complexity."]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M4_FordFulkerson;
